import type { ServicePage } from "../../content/types"
import type { Locale } from "../../content/types"
import { SITE_NAME } from "../../content/site"

/**
 * Service schema. Only rendered on genuine service pages and only with values
 * that correspond to visible page content.
 */
export function buildServiceSchema(service: ServicePage, locale: Locale, pageUrl: string) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name: service.h1?.[locale] ?? service.title[locale],
    description: service.shortDescription[locale],
    url: pageUrl,
    provider: {
      "@type": "Organization",
      name: SITE_NAME,
    },
    areaServed: ["Maastricht", "Limburg", "Netherlands", "Nederland"],
    serviceType: service.title[locale],
  }
}
